import { render, staticRenderFns } from "./AxFilesystemRecentsTable.vue?vue&type=template&id=116c91a2&"
import script from "./AxFilesystemRecentsTable.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemRecentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports